var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "PinView", class: _vm.classes }, [
    _c(
      "div",
      {
        staticClass: "PinViewButton",
        on: {
          click: function ($event) {
            return _vm.toggle()
          },
        },
      },
      [_c("svg-view", { attrs: { name: "pin" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }